




























import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { StompClient } from "@/services/StompClient";

@Component
export default class Header extends Vue {
  @Prop({ default: false }) showMenu!: boolean;
  @Getter("getStaffData", {
    namespace: "AuthStore"
  })
  public getStaffData: any;
  @Getter("socket", { namespace: "Socket" })
  socket: StompClient;
  @Action("disconnect", { namespace: "Socket" })
  disconnectSocket: any;
  public showStaffName: boolean;

  constructor() {
    super();
    this.showStaffName = false;
  }

  onMenuCommand(command: string) {
    if (command == "logout") {
      if (this.socket.isConnected()) {
        this.disconnectSocket();
      }
      this.$router.push("/logout");
    }
  }
}
